<template>
        <card>
           <template slot="header">
              <h3 class="card-title">Undertime Form</h3>
           </template>
           <nav class="row">
              <ol class="breadcrumb arr-right bg-breadcrum">
                 <li class="breadcrumb-item">
                    <router-link to="dashboard"><i class="fa fa-home"></i>&nbsp;Dashboard</router-link>
                 </li>
                 <li class="breadcrumb-item">
                    <router-link to="/hr/undertimerequest">Undertime Request</router-link>
                 </li>
                 <li class="breadcrumb-item active">Undertime Form</li>
              </ol>
           </nav>
           <hr style="margin-top:-10px"/>
           <form @submit.prevent="formSubmit">
              <div class="row">
                 <div class="col-md-12">
                    <label>Employee Name</label>
                    <select class="form-control" v-model="employee_id" v-bind:class="{ 'is-invalid': error_handler && error_handler.employee_id }">
                       <option value="">-- Select One --</option>
                       <option v-for="emp in employees" v-bind:value="emp.id">{{emp.full_name | capitalize}}</option>
                    </select>
                    <span v-if="error_handler.employee_id" class="invalid-feedback">{{ error_handler.employee_id[0] }}</span>
                 </div>
              </div>
              <br/>   
              <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Employee Undertime Request</font>
              <div class="border-box-undertime">
                 <div class="row">
                    <div class="col-md-6">
                       <div class="form-group">
                          <label>Date Filled:</label>
                          <input type="date" v-model="date_filled" class="form-control"  v-bind:class="{ 'is-invalid': error_handler && error_handler.date_filled }">
                          <span v-if="error_handler.date_filled" class="invalid-feedback">{{ error_handler.date_filled[0] }}</span>
                       </div>
                       <div class="form-group">
                          <label>Date of Undertime:</label>
                          <input type="date" v-model="date_of_undertime" class="form-control"  v-bind:class="{ 'is-invalid': error_handler && error_handler.date_of_undertime }">
                          <span v-if="error_handler.date_of_undertime" class="invalid-feedback">{{ error_handler.date_of_undertime[0] }}</span>
                       </div>
                       <div class="form-group">
                          <label>Total Hours:</label>
                          <input type="text" v-model="total_hours" v-mask="['#']" class="form-control"  v-bind:class="{ 'is-invalid': error_handler && error_handler.total_hours }">
                          <span v-if="error_handler.total_hours" class="invalid-feedback">{{ error_handler.total_hours[0] }}</span>
                       </div>
                    </div>
                    <div class="col-md-6">
                       <div class="form-group">
                          <label>Purpose</label>
                          <textarea rows="8"class="form-control" v-model="purpose"  v-bind:class="{ 'is-invalid': error_handler && error_handler.purpose }"></textarea>
                          <span v-if="error_handler.purpose" class="invalid-feedback">{{ error_handler.purpose[0] }}</span>
                       </div>
                    </div>
                 </div>
              </div>
              <br/> <font color="#4285f4" class="title-section"><i class="fa fa-wpforms"></i> Approval Status</font>
              <div class="border-box-undertime">
                 <div class="row">
                    <div class="col-md-4">
                       <label>Supervisor Approval</label>
                       <select class="form-control" v-model="tl_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.tl_status }">
                          <option value="">--Select One--</option>
                          <option value="pending">pending</option>
                          <option value="approved">approved</option>
                          <option value="rejected">rejected</option>
                       </select>
                       <span v-if="error_handler.tl_status" class="invalid-feedback">{{ error_handler.tl_status[0] }}</span>     
                    </div>
                    <div class="col-md-4">
                       <label>Departamental Head Approval</label>
                       <select class="form-control" v-model="asm_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.asm_status }">
                          <option value="">--Select One--</option>
                          <option value="pending">pending</option>
                          <option value="approved">approved</option>
                          <option value="rejected">rejected</option>
                       </select>
                       <span v-if="error_handler.asm_status" class="invalid-feedback">{{ error_handler.asm_status[0] }}</span> 
                    </div>
                    <div class="col-md-4">
                       <label>HR Department Approval</label>
                       <select class="form-control" v-model="hr_status" v-bind:class="{ 'is-invalid': error_handler && error_handler.hr_status }">
                          <option value="">--Select One--</option>
                          <option value="pending">pending</option>
                          <option value="approved">approved</option>
                          <option value="rejected">rejected</option>
                       </select>
                       <span v-if="error_handler.hr_status" class="invalid-feedback">{{ error_handler.hr_status[0] }}</span> 
                    </div>
                 </div>
                 <hr/>
                 <div class="row">
                    <div class="col-md-4">
                       <label>Supervisor Date Approval</label>
                       <div class="form-group" >
                          <input type="date"  class="form-control" v-model="tl_date_approved" v-bind:class="{ 'is-invalid': error_handler && error_handler.tl_date_approved }">
                          <span v-if="error_handler.tl_date_approved" class="invalid-feedback">{{ error_handler.tl_date_approved[0] }}</span> 
                       </div>
                    </div>
                    <div class="col-md-4">
                       <label>Departamental Head Date Approval</label>
                       <div class="form-group">
                          <input type="date"   class="form-control" v-model="asm_date_approved" v-bind:class="{ 'is-invalid': error_handler && error_handler.asm_date_approved }">
                          <span v-if="error_handler.asm_date_approved" class="invalid-feedback">{{ error_handler.asm_date_approved[0] }}</span> 
                       </div>
                    </div>
                    <div class="col-md-4">
                       <label>HR Date Approval</label>
                       <div class="form-group">
                          <input type="date"  class="form-control" v-model="hr_date_approved" v-bind:class="{ 'is-invalid': error_handler && error_handler.hr_date_approved }">
                          <span v-if="error_handler.hr_date_approved" class="invalid-feedback">{{ error_handler.hr_date_approved[0] }}</span> 
                       </div>
                    </div>
                 </div>
              </div>
              <div class="form-group">
                 <div class="float-right">  
                    <br/> <button class="btn btn-info"><i class="fa fa-location-arrow"></i>&nbsp;Submit Request</button> <br/><br/>
                 </div>
              </div>
              <br/> <br/>   
           </form>
        </card>
     </template>
<script>
/* eslint-disable */
import Card from 'src/components/UIComponents/Cards/Card.vue'
export default {
  components: {
    Card,
  },

  data() {
    return {

      employees: [],
      //input
      employee_id: '',
      date_filled: '',
      date_of_undertime: '',
      total_hours: '',
      purpose: '',
      tl_status: '',
      asm_status: '',
      hr_status: '',
      tl_date_approved: '',
      asm_date_approved: '',
      hr_date_approved: '',
      error_handler: []

    }
  },

  mounted: function () {
    this.get_employees()
  },

  methods: {
    get_employees() {
      axios.get('api/employeenodependent')
        .then(response => {
          this.employees = response.data;
        })
        .catch(error => {
          console.log(error.response)
        });
    },

    formSubmit(e) {
      e.preventDefault();
      this.$swal({
          title: 'Are you sure?',
          text: 'Do you want to save',
          type: 'warning',
          showCancelButton: true,
          showCloseButton: false,
        })
        .then((isConfirm) => {
          if (isConfirm === true) {
            axios.post('api/undertimerequest/add', {
                // Undertime request
                employee_id: this.employee_id,
                date_filled: this.date_filled,
                date_of_undertime: this.date_of_undertime,
                total_hours: this.total_hours,
                purpose: this.purpose,
                tl_status: this.tl_status,
                asm_status: this.asm_status,
                hr_status: this.hr_status,
                tl_date_approved: this.tl_date_approved,
                asm_date_approved: this.asm_date_approved,
                hr_date_approved: this.hr_date_approved
              })
              .then(resp => {
                this.$swal('Save', 'You successfully save this file', 'success')
                this.$router.push({
                  name: 'undertime-request'
                })
              })
              .catch(error => {
                if (error.response.status == 422) {
                  this.error_handler = error.response.data.errors
                }
                console.log('response => ', error.response);
              });
          }
        });
    },
  },
  computed: {

  },

}
</script>

    
    
    


// WEBPACK FOOTER //
// src/components/Dashboard/Views/bp-employee-management/todo-undertime-form.vue